// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-card {
    border-radius: 0;
}

ion-text {
    position: absolute;
    padding: 0;
    bottom: 5px;
    background: var(--button-a-background);
    color: var(--button-a-text);
    width: 95%;
    font-size: 20px;
    text-align: center;
    left: 50%;
    transform: translateX(-50%);
}

.subcategory-container {
    padding: 8px;
    padding-top: 0;
    margin-bottom: 4px;
    background: white;
}

.subcategory-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    justify-content: flex-start;
}

.subcategory-box {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 6px 10px;
    background-color: #fff;
    border-radius: 4px;
    border: 0.5px solid #dfdfdfdd;
    font-size: 14px;
    color: #333;
    white-space: nowrap;
    transition: background-color 0.2s ease;
    cursor: pointer;
}

.subcategory-box:hover {
    background-color: #e0e0e0;
}

.subcategory-img {
    width: 20px;
    height: 20px;
    object-fit: cover;
    border-radius: 3px;
}`, "",{"version":3,"sources":["webpack://./src/core/pages/section/components/sections-grid/sections-grid.component.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,sCAAsC;IACtC,2BAA2B;IAC3B,UAAU;IACV,eAAe;IACf,kBAAkB;IAClB,SAAS;IACT,2BAA2B;AAC/B;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,QAAQ;IACR,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,6BAA6B;IAC7B,eAAe;IACf,WAAW;IACX,mBAAmB;IACnB,sCAAsC;IACtC,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;AACtB","sourcesContent":["ion-card {\n    border-radius: 0;\n}\n\nion-text {\n    position: absolute;\n    padding: 0;\n    bottom: 5px;\n    background: var(--button-a-background);\n    color: var(--button-a-text);\n    width: 95%;\n    font-size: 20px;\n    text-align: center;\n    left: 50%;\n    transform: translateX(-50%);\n}\n\n.subcategory-container {\n    padding: 8px;\n    padding-top: 0;\n    margin-bottom: 4px;\n    background: white;\n}\n\n.subcategory-grid {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px;\n    justify-content: flex-start;\n}\n\n.subcategory-box {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    padding: 6px 10px;\n    background-color: #fff;\n    border-radius: 4px;\n    border: 0.5px solid #dfdfdfdd;\n    font-size: 14px;\n    color: #333;\n    white-space: nowrap;\n    transition: background-color 0.2s ease;\n    cursor: pointer;\n}\n\n.subcategory-box:hover {\n    background-color: #e0e0e0;\n}\n\n.subcategory-img {\n    width: 20px;\n    height: 20px;\n    object-fit: cover;\n    border-radius: 3px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
